import store from '@/state/store';

export default [
  {
    path: '/dashboard',
    redirect: '/',
  },
  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/views/Home'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/account/login'),
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter() {
      store.dispatch('auth/userLogout');
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@/views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
];
